<h2 mat-dialog-title>Step 3: Map Touches</h2>
<mat-dialog-content>
  @if (prepareResult) {
    <app-touch-mapping-table
      [prepareResult]="prepareResult"
      (mappingsChanged)="onMappingsChanged($event)"
    ></app-touch-mapping-table>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" type="button">Cancel</button>
  <button mat-raised-button color="primary" (click)="confirm()" type="button" [disabled]="!prepareResult">
    Next
  </button>
</mat-dialog-actions>
